export default __webpack_public_path__ + "static/media/A635.3bcccb32.webp";